import { useDashboard } from '@/hooks/useDashboard';
import FilterBar from './components/FilterBar';
import ChartsSection from './components/ChartsSection';
import RecentSubmissions from './components/RecentSubmissions';
import StatsOverview from './components/StatsOverview';

export default function AdminDashboard() {
  const {
    filters,
    updateFilter,
    stats,
    epiBySector,
    epiByStatus,
    epiByType,
    monthlyData,
    trendData,
    incidentsByType,
    denunciationsByLevel,
    denunciationsBySector,
    recentSubmissions,
  } = useDashboard();

  return (
    <div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 mb-2">
        <div>
          <h1 className="text-xl font-bold text-portal-gray-900">Dashboard</h1>
          <p className="text-sm text-portal-gray-500">Visão geral dos indicadores de Segurança do Trabalho.</p>
        </div>
      </div>

      <FilterBar filters={filters} onFilterChange={updateFilter} />

      {/* Overview with sparklines */}
      <StatsOverview stats={stats} monthlyData={monthlyData} />

      {/* Charts */}
      <ChartsSection
        epiBySector={epiBySector}
        epiByStatus={epiByStatus}
        epiByType={epiByType}
        monthlyData={monthlyData}
        trendData={trendData}
        incidentsByType={incidentsByType}
        denunciationsByLevel={denunciationsByLevel}
        denunciationsBySector={denunciationsBySector}
      />

      {/* Recent Activity */}
      <RecentSubmissions items={recentSubmissions} />
    </div>
  );
}